// import { Formik, Field, Form } from "formik";
// import React from "react";

// const AddTeam = () => {
//     return (
//         <div className="admin-page">
//             <div className="back-title d-flex align-items-center">
//                 <button className="back-btn-title"><i className="icon-icon-11"></i></button>
//                 <h3 className="page-section-title">Add Team Member</h3>
//             </div>
//             <div className="create-building-form">
//                 <Formik
//                     initialValues={{ building_name: "" }}
//                     onSubmit={(values) => {
//                         alert(JSON.stringify(values, null, 2));
//                     }}
//                 >
//                     <Form>
//                         <div className="row">
//                             <div className="col-md-6">
//                                 <div className="form-group">
//                                     <label>Team Member Name</label>
//                                     <Field
//                                         name="team_name"
//                                         className="form-control"
//                                         placeholder="Enter Team Member Name"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="col-md-6">
//                                 <div className="form-group">
//                                     <label>Email address</label>
//                                     <Field
//                                         name="team_address"
//                                         className="form-control"
//                                         placeholder="Enter Email address"
//                                     />
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="form-group">
//                                     <label>Select Access Level</label>
//                                     <div className="d-flex gap-4 flex-wrap">
//                                         <div className="access-level-check form-check p-0 m-0">
//                                             <label
//                                                 className="form-check-label d-flex align-items-center mb-0"
//                                                 htmlFor="fullaccess"
//                                             >
//                                                 <input
//                                                     type="radio"
//                                                     className="form-check-input"
//                                                     id="fullaccess"
//                                                     name="access-level"
//                                                 />
//                                                 <span>Full Access</span>
//                                             </label>
//                                         </div>
//                                         <div className="access-level-check form-check p-0 m-0">
//                                             <label
//                                                 className="form-check-label d-flex align-items-center mb-0"
//                                                 htmlFor="limitedaccess"
//                                             >
//                                                 <input
//                                                     type="radio"
//                                                     className="form-check-input"
//                                                     id="limitedaccess"
//                                                     name="access-level"
//                                                 />
//                                                 <span>Limited Access</span>
//                                             </label>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="button-group d-flex align-items-center mt-3">
//                             <button type="submit" className="btns">Add Team Member</button>
//                         </div>
//                     </Form>
//                 </Formik>
//             </div>
//         </div>
//     )
// }

// export default AddTeam;

import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

// Validation Schema
const buildValidationSchema = (isEdit) =>
  Yup.object().shape({
    team_name: Yup.string().required("Team Member Name is required"),
    team_address: Yup.string().email("Invalid email").required("Email is required"),
    access_level: Yup.string().required("Access level is required"),
    password: isEdit
      ? Yup.string().notRequired()
      : Yup.string()
          .required("Password is required")
          .min(8, "Password must be at least 8 characters long")
          .max(24, "Password must not exceed 24 characters")
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
            "Password must contain at least one uppercase, one lowercase, one number, and one special character."
          ),
  });

const AddTeam = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // userId for edit
  const isEdit = Boolean(id);

  const [initialValues, setInitialValues] = useState({
    team_name: "",
    team_address: "",
    password: "",
    access_level: "2", // default Limited Access
  });
  const [showPassword, setShowPassword] = useState(false);

  // Fetch existing user if editing
  useEffect(() => {
    if (isEdit) {
      const fetchUser = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}auth/user_details/${id}`,
            {
              headers: {
                "api-key": process.env.REACT_APP_API_KEY,
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          if (res.data.status === "success") {
            const u = res.data.data;
            setInitialValues({
              team_name: u.name || "",
              team_address: u.email || "",
              password: "",
              access_level: String(u.access_level || "2"),
            });
          }
        } catch (err) {
          console.error("Error fetching user:", err);
        }
      };
      fetchUser();
    }
  }, [isEdit, id]);

  // Submit handler
  const handleSubmit = async (values, { resetForm }) => {
    try {
      // ✅ build payload without email/password when editing
      const payload = {
        id: id, // only used in edit
        name: values.team_name,
        access_level: Number(values.access_level),
        ...(isEdit
          ? {}
          : { email: values.team_address, password: values.password }), // only send email/password on create
      };

      const url = isEdit
        ? `${process.env.REACT_APP_API_URL}auth/update_user`
        : `${process.env.REACT_APP_API_URL}auth/create_user`;

      const res = await axios.post(url, payload, {
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.status === "success") {
        resetForm();
        navigate("/my-team");
      } else {
        alert(res.data.data || res.data.message || "Failed to save team member");
      }
    } catch (err) {
      console.error("Error saving user:", err);
      const errorMsg =
        err?.response?.data?.data ||
        err?.response?.data?.message ||
        "Failed to save team member";
      alert(errorMsg);
    }
  };

  return (
    <div className="admin-page">
      <div className="back-title d-flex align-items-center">
        <button className="back-btn-title" onClick={() => navigate(-1)}>
          <i className="icon-icon-11"></i>
        </button>
        <h3 className="page-section-title">
          {isEdit ? "Edit Team Member" : "Add Team Member"}
        </h3>
      </div>

      <div className="create-building-form">
        <Formik
          initialValues={initialValues}
          validationSchema={buildValidationSchema(isEdit)}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <Form>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Team Member Name</label>
                  <Field
                    name="team_name"
                    className="form-control"
                    placeholder="Enter Team Member Name"
                  />
                  <ErrorMessage
                    name="team_name"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Email address</label>
                  <Field
                    name="team_address"
                    className="form-control"
                    placeholder="Enter Email address"
                    disabled={isEdit} // ✅ disable when editing
                  />
                  <ErrorMessage
                    name="team_address"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              {!isEdit && (
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Password</label>
                    <div className="position-relative">
                      <Field
                        name="password"
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Password"
                        autoComplete="new-password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword((s) => !s)}
                        className="btn btn-link p-0 position-absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          textDecoration: "none",
                        }}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </div>
              )}

              <div className="col-12">
                <div className="form-group">
                  <label>Select Access Level</label>
                  <div className="d-flex gap-4 flex-wrap">
                    <label className="form-check-label d-flex align-items-center mb-0">
                      <Field
                        type="radio"
                        name="access_level"
                        value="1"
                        className="form-check-input"
                      />
                      <span>Full Access</span>
                    </label>
                    <label className="form-check-label d-flex align-items-center mb-0">
                      <Field
                        type="radio"
                        name="access_level"
                        value="2"
                        className="form-check-input"
                      />
                      <span>Limited Access</span>
                    </label>
                  </div>
                  <ErrorMessage
                    name="access_level"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
            </div>

            <div className="button-group d-flex align-items-center mt-3">
              <button type="submit" className="btns">
                {isEdit ? "Update Team Member" : "Add Team Member"}
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default AddTeam;